import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

interface Timeline {
  QuarterStart: string;
  QuarterEnd: string;
}

export const useNotificationHistory = (
  username?: string,
  timeline?: Timeline,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();

  //const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);

  const [suggestions, setSuggestions] = useState<any[]>([]);

  useEffect(() => {
    if (!enabled || !username || !timeline) return;

    const load = async () => {
      try {
        setLoading(true);

        const qStart = new Date(timeline.QuarterStart);
        const qEnd = new Date(timeline.QuarterEnd);
        qEnd.setDate(qEnd.getDate() + 8);

        const fromDate = `${qStart.getFullYear()}-${qStart.getMonth() + 1}-${qStart.getDate()}`;
        const toDate = `${qEnd.getFullYear()}-${qEnd.getMonth() + 1}-${qEnd.getDate()}`;

        const ntName = "positive\\" + username;
        // const res = await client.get(
        //   "/EmployeeInformation/MySiteSuggestionsHistory",
        //   { params: { username: ntName, fromDate, toDate } }
        // );

        // const history = res.data;

        const res2 = await client.get(
          "/EmployeeInformation/MySiteV2SuggestionsHistory",
          { params: { username: ntName, fromDate, toDate } }
        );
        const history2 = res2.data;
        const mappedSuggestions = history2.map((row: any) => ({
          Id: row.id,
          Title: row.title,
          Text: row.text || row.details,
          Details: row.details,
          NotificationArea: row.notificationArea || "Other",
          Icon: row.icon || "Info",
          SuggestionDate: row.suggestiondate || row.createdDate,
          DateModified: row.modifiedDate,
          ActionLinks: row.actionLinks,
          ActionLink: row.actionLink,
          ActionLinkOption: row.actionLinkOption,
          Category: row.category,
          Region: row.region,
          CurrentValue: row.currentValue,
          RuleListItemId: row.ruleListItemId,
          DismissOnActionClick: row.dismissOnActionClick,
          RequiresDismissNote: row.requiresDismissNote,
          Form: row.form,
          DismissedNotes: row.dismissedNotes || row.dismissednotes,
          DismissedDate: row.dismissedDate,
        }));
        setSuggestions(mappedSuggestions);
        /* if (!Array.isArray(history) || history.length === 0) {
          setData(undefined);
          return;
        } */

        // const formatted = history.map((row: any) => {
        //   const dismissed = new Date(row.dismissedDate);

        //   const dismissedString =
        //     `${dismissed.getFullYear()}-${dismissed.getMonth() + 1}-${dismissed.getDate()}`;

        //   return [
        //     row.title,
        //     row.details,
        //     row.dismissednotes,
        //     dismissedString,
        //   ];
        // });

        // setData(formatted);
      } catch (err) {
        console.error(err);
        //setData(undefined);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, timeline, enabled, client]);

  return { /* data, */ loading, suggestions };
};